import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer } from 'app/_models/customer';
import { Dealer } from 'app/_models/dealer';
import { DormantFeedback } from 'app/_models/dormantFeedback';
import { CustomersService } from 'app/_services/customers.service';
import { DealersService } from 'app/_services/dealers.service';
import { DormantFeedbackService } from 'app/_services/dormantFeedback.service';

@Component({
  selector: 'app-dormantfeedback',
  templateUrl: './dormantfeedback.component.html',
  styleUrls: ['./dormantfeedback.component.css'],
  providers: [ CustomersService, DealersService, DormantFeedbackService ]
})
export class DormantfeedbackComponent implements OnInit {
  
  private existingDormantFeedback: DormantFeedback;
  private customer: Customer;
  private dealer: Dealer;
  private customerInfoResolved: boolean = false;
  private loading: boolean = false;
  private showSuccessMessage: boolean = false;
  private showErrorMessage: boolean = false;

  // Feedback variables
  // feedback checkboxes model
  private feedbackCheckboxesModel = {
    forgotBooking: false,
    carSold: false,
    moved: false,
    carWorkshop: false,
    customerService: false,
    price: false
  }
  // feedback extra text
  private feedbackText : string;


  // Customer query parameter variables
  private customerDealerId: string;
  private customerMauticId: string;
  private customerRegNumber: string;
  private feedbackChoiceFromMail: string;

  constructor(
    private activatedRoute : ActivatedRoute,
    private router : Router,
    private customerService: CustomersService,
    private dealerService: DealersService,
    private dormantFeedbackService: DormantFeedbackService) { }

  ngOnInit() {

    // Get the customer data from the query params
    this.activatedRoute.queryParams.subscribe((params) => {
      this.customerDealerId = params["dealer"];
      this.customerMauticId = params["customer"];
      this.customerRegNumber = params["regnr"];
      this.feedbackChoiceFromMail = params["feedbackChoice"];

      //Now, validate that all query parameters is present
      this.validateQueryParams();
    });

  }

  validateQueryParams(): void {
    // If the query parameters wasn't provided, redirect the user to the dealers external site.
    if (!this.customerDealerId || !this.customerMauticId || !this.customerRegNumber) {
      window.location.href = this.getErrorRedirectUrl();
    }
    else {
      this.getDealerInfo();
    }
  }

  getDealerInfo() : void {
    this.dealerService.read(this.customerDealerId)
      .subscribe(
        (dealer) => {
          this.dealer = dealer;
          this.getCustomerInfo();
        },
        (error) => {
          window.location.href = this.getErrorRedirectUrl();
        }
      );
  }

  getCustomerInfo() : void {
    this.customerService.getCustomerByMauticIdAndRegistration(
      this.customerMauticId, 
      this.customerRegNumber, 
      this.customerDealerId)
      .subscribe(
        (customer) => {
          this.customerInfoResolved = true;
          this.customer = customer;
          this.validateEmailFeedbackChoice();
        },
        (error) => {
          window.location.href = this.getErrorRedirectUrl();
        } 
      );
  }

  validateEmailFeedbackChoice(): void { 

    // If feedback choice query param is not null, set the corresponding feedback checkbox to true

    if (this.feedbackChoiceFromMail) {
      let propertyName = null;
      switch (this.feedbackChoiceFromMail) {
        case "forgotBooking":
          this.feedbackCheckboxesModel.forgotBooking = true;
          propertyName = "forgotBooking";
          break;
        case "carSold":
          this.feedbackCheckboxesModel.carSold = true;
          propertyName = "carSold";
          break;
        case "moved":
          this.feedbackCheckboxesModel.moved = true;
          propertyName = "moved";
          break;
        case "carWorkshop":
          this.feedbackCheckboxesModel.carWorkshop = true;
          propertyName = "carWorkshop";
          break;
        case "customerService":
          this.feedbackCheckboxesModel.customerService = true;
          propertyName = "customerService";
          break;
        case "price":
          this.feedbackCheckboxesModel.price = true;
          propertyName = "price";
          break;

        }
        // Store the email feedback choice in the database.
        this.sendEmailChoiceFeedback(propertyName);
    }
    else {
      this.checkForExistingFeedbackData();
    }
  }

  getErrorRedirectUrl(): string {
    return "https://nellemann.dk"
  }

  anyFeedbackGiven(): boolean {
    // Check if any of the checkboxes has been checked
    for (const checkbox in this.feedbackCheckboxesModel) {
      if (this.feedbackCheckboxesModel[checkbox]) {
        return true;
      }
    }
    return false;
  }

  sendEmailChoiceFeedback(choiceProperty: string): void {
    // Check if dormant feedback already exists for customer
    this.dormantFeedbackService.findByCustomerId(this.customer._id)
      .subscribe(
        (dormantFeedback) => {
          // Assign this.existingDormantFeedback var
          this.existingDormantFeedback = dormantFeedback;

          // Update the form with existing feedback data
          this.updateFormWithExistingFeedback(dormantFeedback);

          // Time to update the existing feedback data with the newly selected feedback choice
          dormantFeedback[choiceProperty] = true;
          this.dormantFeedbackService.update(dormantFeedback)
            .subscribe(
              (response) => {
                
              },
              (error) => {
                
              }
            );
        },
        (error) => {
          // The dormant feedback has not been created yet, create it
          this.dormantFeedbackService.create(this.getDormantFeedbackFromForm())
            .subscribe(
              (dormantFeedback) => {
                // Assign 'this.existingDormantFeedback' to the newly created one
                this.existingDormantFeedback = dormantFeedback
              },
              (error) => {
                //Dormant feedback wasn't inserted into database
              }
            );
        } 
      );
  }

  checkForExistingFeedbackData(): void {
    this.dormantFeedbackService.findByCustomerId(this.customer._id)
      .subscribe(
        (dormantFeedback) => {
          // Assign this.existingDormantFeedback var
          this.existingDormantFeedback = dormantFeedback;

          // Update the form with existing feedback data
          this.updateFormWithExistingFeedback(dormantFeedback);
        },
        (error) => {
          // No existing feedback data for this customer was found
        }
      );
  }

  updateFormWithExistingFeedback(dormantFeedback: DormantFeedback) : void {
    this.feedbackCheckboxesModel.carSold = this.feedbackCheckboxesModel.carSold || dormantFeedback.carSold ? true : false;
    this.feedbackCheckboxesModel.carWorkshop = this.feedbackCheckboxesModel.carWorkshop || dormantFeedback.carWorkshop ? true : false;
    this.feedbackCheckboxesModel.customerService = this.feedbackCheckboxesModel.customerService || dormantFeedback.customerService ? true : false;
    this.feedbackCheckboxesModel.forgotBooking = this.feedbackCheckboxesModel.forgotBooking || dormantFeedback.forgotBooking ? true : false;
    this.feedbackCheckboxesModel.moved = this.feedbackCheckboxesModel.moved || dormantFeedback.moved ? true : false;
    this.feedbackCheckboxesModel.price = this.feedbackCheckboxesModel.price || dormantFeedback.price ? true : false;
    this.feedbackText = this.feedbackText ? this.feedbackText : dormantFeedback.message;
  }

  updateFeedback(): void {
    this.loading = true;
    
    if (this.existingDormantFeedback) {
      //We already have existing feedback data, so we just need to update it
      this.existingDormantFeedback.forgotBooking = this.feedbackCheckboxesModel.forgotBooking;
      this.existingDormantFeedback.carSold = this.feedbackCheckboxesModel.carSold;
      this.existingDormantFeedback.moved = this.feedbackCheckboxesModel.moved;
      this.existingDormantFeedback.carWorkshop = this.feedbackCheckboxesModel.carWorkshop;
      this.existingDormantFeedback.customerService = this.feedbackCheckboxesModel.customerService;
      this.existingDormantFeedback.price = this.feedbackCheckboxesModel.price;
      this.existingDormantFeedback.message = this.feedbackText;

      this.dormantFeedbackService.update(this.existingDormantFeedback)
        .subscribe(
          (response) => {
            //Display success message
            this.showSuccessMessage = true;
            this.beginRedirectAfterFeedbackSave();
          },
          (error) => {
            //Display error message
            this.showErrorMessage = true;
          },
          () => {
            this.loading = false;
          }
        );
    }
    else {
      //We did not have any existing feedback data, so we need to create it
      this.dormantFeedbackService.create(this.getDormantFeedbackFromForm())
        .subscribe(
          (dormantFeedback) => {
            //Now, update the this.existingDormantFeedback
            this.existingDormantFeedback = dormantFeedback;

            //Display success message
            this.showSuccessMessage = true;
            this.beginRedirectAfterFeedbackSave();
          },
          (error) => {
            //Display error message
            this.showErrorMessage = true;
          },
          () => {
            this.loading = false;
          } 
        );
    }
  }

  getDormantFeedbackFromForm() {
    let customer = new Customer();
    customer._id = this.customer._id;

    let dealer = new Dealer();
    dealer._id = this.dealer._id;

    let dormantFeedback = new DormantFeedback();
    dormantFeedback.customer = customer;
    dormantFeedback.dealer = dealer;
    dormantFeedback.mauticId = this.customerMauticId;
    dormantFeedback.forgotBooking = this.feedbackCheckboxesModel.forgotBooking;
    dormantFeedback.carSold = this.feedbackCheckboxesModel.carSold;
    dormantFeedback.moved = this.feedbackCheckboxesModel.moved;
    dormantFeedback.carWorkshop = this.feedbackCheckboxesModel.carWorkshop;
    dormantFeedback.customerService = this.feedbackCheckboxesModel.customerService;
    dormantFeedback.price = this.feedbackCheckboxesModel.price;
    dormantFeedback.message = this.feedbackText;

    return dormantFeedback;
  }

  beginRedirectAfterFeedbackSave() {
    const redirectUrl = this.getErrorRedirectUrl();
    window.setTimeout(function(){
      window.location.href = redirectUrl;
    }, 3000);
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/dormantfeedback/dormantfeedback.component.ts